import {
    Container,
    Typography,
    Checkbox,
    FormControlLabel,
  } from "@mui/material";
  import React, { Fragment, useState, useEffect } from "react";
  import Layout from "../components/layouts/Layout";
  import Breadcrumbs from "../components/breadcrumbs/";
  import Payment from "../components/cart/Payment";
  import AddressList from "../components/address/list";
  import { useAddress } from "../context/AddressContext";
  
  const Checkout = () => {
    const { addresses } = useAddress();
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [addressCount, setAddressCount] = useState(0);
    const [isPickup, setIsPickup] = useState(false); // New state for pickup option
    const [deliveryType, setDeliveryType] = useState("delivery"); // Default delivery type
    const [checkoutData, setCheckoutData] = useState(null); // To hold the checkout data
  
    // Update address count when addresses change
    useEffect(() => {
      setAddressCount(addresses.length);
      // Load checkout data from localStorage
      const storedCheckoutData = JSON.parse(localStorage.getItem("checkoutData"));
      if (storedCheckoutData) {
        setCheckoutData(storedCheckoutData);
      }
    }, [addresses]);
  
    const handlePickupChange = (event) => {
      const isChecked = event.target.checked;
      setIsPickup(isChecked);
      setDeliveryType(isChecked ? "pickup" : "delivery");
      if (isChecked) {
        setSelectedAddress(null); // Clear selected address if pickup is chosen
      }
    };
  
    return (
      <Fragment>
        <Layout title={"Checkout"} logo={"/assets/images/logo.jpeg"}>
          <Breadcrumbs title={"Checkout"} crumb={"Checkout"} />
          <Container>
            <div className="restaurant-name">
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                Checkout
              </Typography>
              <Typography variant="body2" sx={{ color: "#aaa" }}>
                Delivery Address, Payment Method, and More
              </Typography>
            </div>
            <div style={{ borderTop: "1px solid #ddd", margin: "15px 0" }} />
  
            {/* Pickup Option */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={isPickup}
                  onChange={handlePickupChange}
                  color="error"
                />
              }
              label="Pickup (No delivery address needed)"
              sx={{ marginBottom: "15px" }}
            />
  
            {/* Address List (Hidden if Pickup is selected) */}
            {!isPickup && (
              <AddressList
                addresses={addresses}
                setSelectedAddress={setSelectedAddress}
                SelectedAddress={selectedAddress}
                count={setAddressCount}
              />
            )}
  
            <div style={{ borderTop: "1px solid #ddd", margin: "15px 0" }} />
  
            {/* Pass checkout data to Payment */}
            <Payment
              SelectedAddress={selectedAddress}
              deliveryType={deliveryType}
              isPickup={isPickup} 
            />
          </Container>
        </Layout>
      </Fragment>
    );
  };
  
  export default Checkout;
  